import { connect } from 'react-redux';
import UploadImage from '../components/UploadImage'
import { imageUpload } from '../actions';

const mapStateToProps = (state, ownProps) => {
  return {
    imageData: state.imageUpload,
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    imageUploadHandler: (data) => {
      dispatch(imageUpload(data));
    },
  };
};


const UploadImageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadImage);

export default UploadImageContainer;
